import { useEffect, useMemo, useRef, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import bgmusic from "../../assets/audio/bgmusic.mp3";
import "./AppShell.css";

const navItems = [
  { to: "/", label: "홈" },
  { to: "/crops", label: "크롭 정보" },
  { to: "/board", label: "게시판" },
  { to: "/profile", label: "마이페이지" },
];

export default function AppShell() {
  const { user, logout } = useAuth();
  const [now, setNow] = useState(new Date());
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const signalDots = useMemo(() => Array.from({ length: 24 }, (_, index) => ({
    id: index,
    left: `${(index * 37) % 97}%`,
    top: `${(index * 61) % 93}%`,
    delay: `${(index % 8) * 0.31}s`,
  })), []);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    audioRef.current?.play().catch(() => {
      // 일부 브라우저는 사용자 설정에 따라 소리 자동재생을 차단할 수 있습니다.
    });
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const timestamp = new Intl.DateTimeFormat("ko-KR", {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).format(now);

  return (
    <div className="legacy-shell">
      <audio ref={audioRef} src={bgmusic} autoPlay loop preload="auto" />
      <div className="signal-field" aria-hidden="true">{signalDots.map((dot) => <i key={dot.id} style={{ left: dot.left, top: dot.top, animationDelay: dot.delay }} />)}</div>
      <div className="legacy-inner">
        <div className="terminal-line">
          <span>{timestamp} / NODE GB-33-A / SIGNAL UNSTABLE</span>
          <span>USER {user?.survivorId} · {user?.name}</span>
        </div>
        <header className="legacy-header">
          <div className="survival-banner">
            <p>CHIKITOKA SURVIVOR NETWORK</p>
            <h1>환영합니다. 오늘도 생존을 기원합니다.<br />금일 생존자 수 : 4,112명<span>(-443)</span></h1>
          </div>
          <nav className="legacy-nav" aria-label="주 메뉴">
            {navItems.map((item) => <NavLink key={item.to} to={item.to} end={item.to === "/"}>{item.label}</NavLink>)}
          </nav>
          <div className="legacy-controls">
            <button type="button" onClick={handleLogout}>[접속 종료]</button>
          </div>
        </header>
        <main className="legacy-content"><Outlet /></main>
      </div>
    </div>
  );
}
